export default "__VITE_ASSET__3e4e0d6a__"